// MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS
export const MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS = "MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS";
export const MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS_SUCCESS = "MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS_SUCCESS";
export const MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS_FAILURE = "MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS_FAILURE";
export const MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS_RESET = "MOVE_WORKFLOW_FUND_DETAILS_GENERATE_DOCS_RESET";
